import { createUseStyles } from 'react-jss'

import colors from './colors'

interface StyleProps {
  columns: number
  rows: number
  columnGap: string
  rowGap: string
  selectedColor: string
  unselectedColor: string
  hoveredColor: string
}

const useStyles = createUseStyles({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    userSelect: 'none'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: (props: StyleProps) => `auto repeat(${props.columns}, 1fr)`,
    gridTemplateRows: (props: StyleProps) => `auto repeat(${props.rows}, 1fr)`,
    columnGap: (props: StyleProps) => props.columnGap,
    rowGap: (props: StyleProps) => props.rowGap,
    width: '100%'
  },
  gridCell: {
    placeSelf: 'stretch',
    touchAction: 'none'
  },
  dateCell: {
    width: '100%',
    height: '25px',
    backgroundColor: (props: StyleProps) => props.unselectedColor,
    '&:hover': {
      backgroundColor: (props: StyleProps) => props.hoveredColor
    }
  },
  dateCellSelected: {
    backgroundColor: (props: StyleProps) => props.selectedColor
  },
  timeText: {
    fontSize: '14px',
    fontWeight: 300,
    lineHeight: `${14 * 1.37}px`,
    color: colors.grey,
    textAlign: 'right',
    margin: 0,
    marginRight: '4px',
    '@media (max-width: 699px)': {
      fontSize: '10px'
    }
  }
})

export default useStyles
